import {
  Firestore,
  connectFirestoreEmulator,
  getFirestore,
} from "firebase/firestore";
import { app, resolveEmulatorAddress, useEmulator } from "./app";

export const db: Firestore = getFirestore(app);

if (useEmulator) {
  const { host, port } = resolveEmulatorAddress("firestore");
  connectFirestoreEmulator(db, host, port);
}
